import GuardianIndex from '@/views/guardians/GuardianIndex.vue';
import AddGuardian from '@/views/guardians/AddGuardian.vue';
import EditGuardian from '@/views/guardians/EditGuardian.vue';
import GuardianStudents from '@/views/guardians/GuardianStudents.vue';
import AddStudentToGuardian from '@/views/guardians/AddStudentToGuardian.vue';

export default [
  {
    path: '/guardians',
    name: 'guardians.index',
    component: GuardianIndex,
    meta: { 
      title: 'guardians.indexTitle',
      requiresAuth: true,
      requiredPerm: 'guardians.display'
    },
    children: [
      {
        path: 'create',
        name: 'guardians.create',
        component: AddGuardian,
        meta: { 
          title: 'guardians.addTitle',
          requiresAuth: true,
          requiredPerm: 'guardians.create'
        }
      },
      {
        path: '/guardians/:id/wallet',
        name: 'guardians.wallet',
        component: () => import('@/views/guardians/GuardianWallet.vue'),
        meta: { 
          title: 'guardians.walletTitle',
          requiresAuth: true,
          requiredPerm: 'guardian_wallet.display'
        },
        props: true,
        children: [
          {
            path: 'charge',
            name: 'guardians.wallet.charge',
            component: () => import('@/views/guardians/ChargeWallet.vue'),
            meta: { 
              title: 'guardians.walletChargeTitle',
              requiresAuth: true,
              requiredPerm: 'guardian_wallet.charge'
            },
            props: true
          },
          {
            path: 'edit/:invoiceId',
            name: 'guardians.wallet.edit',
            component: () => import('@/views/guardians/EditWalletInvoice.vue'),
            meta: { 
              title: 'guardians.walletEditInvoiceTitle',
              requiresAuth: true,
              requiredPerm: 'guardian_wallet.update'
            },
            props: true
          }
        ],
      },
      {
        path: ':id/edit',
        name: 'guardians.edit',
        component: EditGuardian,
        meta: { 
          title: 'guardians.editTitle',
          requiresAuth: true,
          requiredPerm: 'guardians.update'
        },
        props: true
      },
      {
        path: ':id/students',
        name: 'guardians.students',
        component: GuardianStudents,
        meta: { 
          title: 'guardians.studentsTitle',
          requiresAuth: true,
          hideBreadcrumbForGuardian: true,
          requiredPerm: 'student_guardians.display'
        },
        props: true,
        children: [
          {
            path: '/guardians/:id/students/:studentId/charge-wallet',
            name: 'guardians.students.charge-wallet',
            component: () => import('@/views/guardians/StudentWalletCharge.vue'),
            meta: { 
              title: 'guardians.studentsChargeWalletTitle',
              requiresAuth: true,
              requiredPerm: 'student_wallet.charge'
            }
          },
        ]
      },
      {
        path: ':id/students/add',
        name: 'guardians.students.add',
        component: AddStudentToGuardian,
        meta: { 
          title: 'guardians.addStudentTitle',
          requiresAuth: true,
          requiredPerm: 'guardian_students.create'
        }
      },
    ]
  },
  {
    path: '/guardians/:id/students',
    name: 'guardians.students.payments',
    component: GuardianStudents,
    meta: { 
      title: 'guardians.studentsTitle',
      requiresAuth: true,
      requiredPerm: 'guardian_students.display'
    },
    props: true
  },
];
